module.exports = __webpack_public_path__ + "static/img/zgdwgxb.a3c8854f.jpg";